<template>
  <NuxtLink
    class="menuItems link-type overflow-visible whitespace-nowrap px-2 leading-[22px] text-ng600 text-ng800 focus:outline-none focus-visible:ring focus-visible:ring-ng70 focus-visible:ring-opacity-75"
    :class="bordered"
    :to="localePath(props.to)"
  >
    <slot>
      <span class="relative leading-[1.2]" :class="{ underlined: !props.bordered }">
        <slot name="title">
          {{ $t(`pages.${props.to.name}.title`) }}
        </slot>
      </span>
    </slot>
  </NuxtLink>
</template>
<script setup lang="ts">
const props = defineProps({
  to: {
    type: Object,
    required: true,
  },
  bordered: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { t: $t } = useI18n();

const localePath = useLocalePath();

const bordered = computed(() => {
  return {
    "border border-ng70 hover:border-ng60": props.bordered,
    "py-2": props.bordered,
    "py-3": !props.bordered,
  };
});
</script>
<style lang="scss">
.link-type > .underlined {
  padding-bottom: 2px;
  &::after {
    content: "";
    width: 100%;
    height: 80%;
    position: absolute;
    background: theme("colors.links-highlight");
    left: 0;
    bottom: 2px;
    z-index: -1;
    transform: scaleX(1) scaleY(0.4);
    transform-origin: center bottom;
    transition: transform 0.22s ease-out;
  }
}

.link-type {
  &:hover {
    > .underlined::after {
      transform: scaleX(1) scaleY(1);
    }
  }
}
</style>
